import React from 'react';
export function Footer() {
  return <footer className="border-t border-border px-6 py-[30px] text-center font-sans text-[0.76rem] text-text-muted leading-[1.8]" data-id="element-54">
      <p data-id="element-55">
        napftagebuch.de &nbsp;·&nbsp; Ehrliche Erfahrungsberichte von
        Hundeeltern
      </p>
      <p className="mt-[6px]" data-id="element-56">
        <a href="#" className="text-text-muted hover:text-text transition-colors" data-id="element-57">
          Impressum
        </a>{' '}
        &nbsp;·&nbsp;
        <a href="#" className="text-text-muted hover:text-text transition-colors" data-id="element-58">
          Datenschutz
        </a>{' '}
        &nbsp;·&nbsp; Dieser Beitrag enthält gesponserte Inhalte (Advertorial)
      </p>
    </footer>;
}